require('./preGrantedCreditStepOne.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @core
const { FormattedText } = require('core/i18n').i18n;

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
const { OKMessage } = require('commonsComponents/OKMessage');

//@components
const PreGrantedCreditLegalConfirmation = require('../preGrantedCreditLegalConfirmation/preGrantedCreditLegalConfirmation');

// @constants
const { PRE_GRANTED_CREDIT_STANDARD, PRE_GRANTED_CREDIT_SUBTYPE, PRE_GRANTED_CREDIT_TYPE } = require('constants/index');
class PreGrantedCreditStepOne extends React.Component {

    componentDidMount() {
        const { getContractInformation, immPreGrantedCredit } = this.props;

        if (!immPreGrantedCredit.get('contractInformationStepOne')) {
            getContractInformation();
        }
    }

    buildContent() {
        const { immPreGrantedCredit, immFlagBasedFeatures } = this.props;
        const contractInformation = immPreGrantedCredit.get('contractInformationStepOne');
        let content;

        if (immPreGrantedCredit.get('isFetchingContractInformationStepOne')) {
            content = <LoadingSection />;
        } else if(__CONTACT_CENTER__){
            content = <React.Fragment><OKMessage type="informative" children={<FormattedText value="contractsView-preGrantedCreditStep1MandatoryText" />} ></OKMessage>
            <HTMLSafeInjector message={contractInformation} /></React.Fragment>
        }
        else{
            {
                content = <HTMLSafeInjector message={contractInformation} />;
            }
        }

        return content;
    }

    buildLegalConfirmation() {
        const { immPreGrantedCredit, immProfile, preContractualMail, requestProfile, resetPrecontractualMail,
            sendPreContractualMail, updateConfirmationCheckbox, immFlagBasedFeatures, sendOverDraftSimpleEmail } = this.props;

        return (
            <PreGrantedCreditLegalConfirmation
                immPreGrantedCredit={immPreGrantedCredit}
                immProfile={immProfile}
                preContractualMail={preContractualMail}
                requestProfile={requestProfile}
                resetPrecontractualMail={resetPrecontractualMail}
                sendPreContractualMail={sendPreContractualMail}
                standar={PRE_GRANTED_CREDIT_STANDARD}
                subType={PRE_GRANTED_CREDIT_SUBTYPE}
                type={PRE_GRANTED_CREDIT_TYPE}
                updateConfirmationCheckbox={updateConfirmationCheckbox}
                immFlagBasedFeatures={immFlagBasedFeatures}
                sendOverDraftSimpleEmail={sendOverDraftSimpleEmail}
            />
        );
    }

    render() {
        const content = this.buildContent();
        const legalConfirmation = this.buildLegalConfirmation();

        return (
            <section className="pre-granted-credit-step-one" >
                <div className="pre-granted-credit-step-one__title">
                    <FormattedText value="contractsView-preGrantedCreditStep1Title" />
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        {content}
                        {legalConfirmation}
                    </div>
                </div>
            </section>
        );
    }
}

PreGrantedCreditStepOne.propTypes = {
    getContractInformation: PropTypes.func.isRequired,
    immPreGrantedCredit: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    updateConfirmationCheckbox: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    sendOverDraftSimpleEmail:PropTypes.func.isRequired
};

module.exports = PreGrantedCreditStepOne;
